// Can be used Symbol as well(much better)
export const DISPUTE_TYPES = {
    DEFAULT: 'DEFAULT',
    GOVERN: 'GOVERN'
}
